const auth = {
  auth: {
    signin: {
      title: "登录",
      email: "电子邮箱",
      password: "密码",
      remember: "记住我",
      forgot: "忘记密码？",
      submit: "登录",
      create: "没有账户？",
      createLink: "创建账户",
    },
    signup: {
      title: "创建账户",
      email: "电子邮箱",
      password: "密码",
      confirmPassword: "确认密码",
      terms: "我同意条款和条件",
      submit: "注册",
      login: "已有账户？",
      loginLink: "登录",
    },
    forgot: {
      title: "忘记密码",
      description: "输入您的电子邮箱，我们将向您发送重置密码的链接。",
      email: "电子邮箱",
      submit: "发送重置链接",
      back: "返回登录",
      success: "重置链接已发送到您的邮箱。请检查您的收件箱。",
    },
    reset: {
      title: "重置密码",
      description: "为您的账户创建新密码。",
      password: "新密码",
      confirmPassword: "确认密码",
      submit: "重置密码",
      login: "返回登录",
      success: "您的密码已成功重置。即将跳转到登录页面。",
      invalidToken: "重置令牌无效或缺失。请重新请求密码重置链接。",
    },
    email: "电子邮件",
    password: "密码",
    confirmPassword: "确认密码",
    forgotPassword: "忘记密码？",
    rememberMe: "记住我",
    noAccount: "还没有账号？",
    hasAccount: "已有账号？",
    createAccount: "创建账号",
    resetPassword: "重置密码",
    resetPasswordLink: "重置密码链接",
    backToSignIn: "返回登录",
    termsAndConditions: "我同意服务条款和隐私政策",
    emailSent: "重置密码链接已发送到您的邮箱",
    checkEmail: "请检查您的邮箱",
    passwordChanged: "密码已成功更改",
    signUpSuccess: "注册成功，请检查您的邮箱进行验证",
    invalidCredentials: "邮箱或密码错误",
    passwordMismatch: "两次输入的密码不一致",
    passwordTooShort: "密码至少需要 8 个字符",
    invalidEmail: "请输入有效的电子邮件地址",
    emailRequired: "请输入电子邮件地址",
    passwordRequired: "请输入密码",
    confirmPasswordRequired: "请确认密码",
    termsRequired: "您必须同意服务条款和隐私政策",
    userNotFound: "找不到该用户",
    emailInUse: "该邮箱已被注册",
    weakPassword: "密码强度太弱",
    resetInvalidToken: "重置令牌无效或已过期，请重新获取密码重置链接",
    unexpectedError: "发生了意外错误，请稍后再试",
    signinText: "登录",
    signupText: "注册",
  },
};

export default auth; 